<template>
  <NuxtLayout>
    <div
      v-loading="ctrl.loading"
      class="app_container detail_content"
    >
      <div
        v-if="opts.info.id"
        class="course_info"
      >
        <div
          ref="head"
          class="course_info_header"
        >
          <div class="course_info_content">
            <div class="course_nav">
              <el-breadcrumb :separator-icon="ArrowRight">
                <el-breadcrumb-item :to="{ path: '/' }">
                  <span class="nav_course_title">首页</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/course/list' }">
                  <span class="nav_course_title">课程中心</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/course/list', query: { courseType: opts.info.courseType } }">
                  <span class="nav_course_title">{{ opts.PeriodTypeEnum[opts.info.courseType] }}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                  <div class="nav_course_title tx-ov">
                    {{ opts.info.courseName }}
                  </div>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="course_message">
              <div class="course_cover">
                <img
                  :src="opts.info.courseCover"
                  class="course_cover_img"
                >
              </div>
              <div class="course_msg_content">
                <div class="course_price_content">
                  <div class="course_name">
                    <span class="course_name_tag">{{ opts.PeriodTypeEnum[opts.info.courseType] }}</span>
                    <span>{{ opts.info.courseName }}</span>
                  </div>
                  <div class="course_int">
                    <div class="course_int_text tx-ov">
                      课程描述：{{ opts.info.courseDesc || "无" }}
                    </div>
                    <client-only>
                      <el-popover
                        v-if="opts.info.courseDesc.length > 35"
                        :width="600"
                        placement="bottom-end"
                        :offset="-24"
                        :show-arrow="false"
                        trigger="hover"
                      >
                        <span class="course_desc_tip">{{ opts.info.courseDesc }}</span>
                        <template #reference>
                          <span class="loadmore">更多</span>
                        </template>
                      </el-popover>
                    </client-only>
                  </div>
                </div>
                <div class="course_price_info">
                  <div class="course_price">
                    <span class="course_tip">价格：</span>
                    <span
                      :style="{ color: '#F01414' }"
                      class="price_now"
                    >
                      <span
                        v-if="opts.info.price > 0"
                        class="price_icon"
                      >￥</span>
                      {{ opts.info.price ? opts.info.price.toFixed(2) : "免费" }}
                    </span>
                    <span
                      v-if="opts.info.linePrice > 0"
                      class="price_old"
                    >
                      <span class="price_icon">￥</span>
                      {{ opts.info.linePrice.toFixed(2) }}
                    </span>
                  </div>
                  <div class="course_price mgt10" v-if="opts.info.price > 0 && opts.shopData?.config.vipEnableMarketing">
                    <span class="course_tip" >推荐会员价：</span>
                    <span
                      v-if="userInfo && userInfo.isVip"
                      :style="{ color: '#F01414' }"
                      class="discount_price"
                    >
                      ￥{{ opts.info.discountPrice.toFixed(2) }}
                    </span>
                    <span
                      v-else
                      :style="{ color: '#F01414' }"
                      class="discount_price"
                    >
                      ￥{{ opts.info.otherPrice.toFixed(2) }}
                    </span>
                  </div>
                </div>
                <div
                  v-if=" opts.info.examExist || opts.info.practiceExist || opts.info.certIssue"
                  class="course_cell"
                >
                  <span class="course_tip">包含内容：</span>
                  <span
                    v-if="opts.info.examExist"
                    class="course_cell_item cu"
                    @click="handleChangeExam('exam')"
                  ><img src="@/assets/along.svg">&nbsp;随堂考试：1场</span>
                  <span
                    v-if="opts.info.practiceExist"
                    class="course_cell_item cu"
                    @click="handleChangeExam('practice')"
                  ><img
                    src="@/assets/practice.svg"
                  >&nbsp;随堂练习：1个</span>
                  <span
                    v-if="opts.info.certIssue"
                    class="course_cell_item"
                  ><img src="@/assets/credential.svg">&nbsp;课程证书：1张
                  </span>
                </div>
                <div
                  v-if="opts.info.courseAuthor"
                  class="course_int"
                >
                  <div class="course_int_text tx-ov">
                    课程作者：{{ opts.info.courseAuthor }}
                  </div>
                  <client-only>
                    <el-popover
                      v-if="opts.info.courseAuthor.length > 35"
                      :width="600"
                      placement="bottom-end"
                      :offset="-24"
                      :show-arrow="false"
                      trigger="hover"
                    >
                      <span class="course_desc_tip">{{ opts.info.courseAuthor }}</span>
                      <template #reference>
                        <span class="loadmore">更多</span>
                      </template>
                    </el-popover>
                  </client-only>
                </div>
                <div
                  v-if="opts.info.teacherExist"
                  class="course_cell"
                >
                  <span class="course_tip">授课教师：</span>
                  <div class="flex_teacher">
                    <div class="course_cell_item teacher_wrap">
                      <div
                        v-for="(teacher, i) in opts.info.teacherList.filter((item, i) => i < 5)"
                        class="teacher_warp_item"
                        @click="handleOpenTeacher(teacher)"
                      >
                        <img
                          :key="i"
                          :src="teacher.headImg"
                          :title="teacher.nickname"
                          class="mgl3 cover_teacher"
                        >
                        <div class="teacher_name">
                          {{ teacher.nickname }}
                        </div>
                      </div>
                    </div>
                    <client-only>
                      <el-popover
                        v-if="opts.info.teacherList.length > 5"
                        :content="opts.info.courseDesc"
                        :width="600"
                        placement="bottom-end"
                        :offset="-24"
                        :show-arrow="false"
                        trigger="hover"
                      >
                        <div class="course_cell_item">
                          <div
                            v-for="(teacher, i) in opts.info.teacherList"
                            class="teacher_warp_item"
                            @click="handleOpenTeacher(teacher)"
                          >
                            <img
                              :key="i"
                              :src="teacher.headImg"
                              :title="teacher.nickname"
                              class="mgl3 cover_teacher"
                            >
                            <div class="teacher_name">
                              {{ teacher.nickname }}
                            </div>
                          </div>
                        </div>
                        <template #reference>
                          <div
                            class="course_in_icon"
                            @click="handleChangeTeach"
                          >
                            更多
                          </div>
                        </template>
                      </el-popover>
                    </client-only>
                  </div>
                </div>
                <div class="course_cell course_cell_valid">
                  <span class="course_tip">有效期：</span>
                  <template v-if="opts.info.courseStatus === 3">
                    <span class="valid_text">已过期</span>
                  </template>
                  <template v-else>
                    <span v-if="opts.info.validityType === 1">永久有效</span>
                    <span v-else-if="opts.info.validityType === 2">{{ opts.info.beginTime }} 至
                      {{ opts.info.endTime }}
                    </span>
                    <span v-else-if="opts.info.validityType === 3">
                      {{ opts.info.days }}天
                    </span>
                  </template>
                </div>
                <div class="course_bottom">
                  <div class="course_btn_info">
                    <div class="course_btn">
                      <template v-if="opts.info.courseStatus">
                        <el-button
                          v-if="opts.info.courseStatus === 1"
                          class="buy_btn"
                          type="primary"
                          @click="handleMake"
                        >
                          预约课程
                        </el-button>
                        <el-button
                          v-else-if="opts.info.courseStatus === 2"
                          class="buy_btn"
                          type="info"
                        >
                          待开课
                        </el-button>
                        <el-button
                          v-else-if="opts.info.courseStatus === 3"
                          class="buy_btn"
                          type="primary"
                          @click="handleOpenOther"
                        >
                          查看其它课程
                        </el-button>
                      </template>
                      <!-- <el-button v-if="!opts.info.courseStatus" class="buy_btn" type="primary" @click="handleBuy">
                        <template v-if="opts.info.buyStatus">{{ !opts.info.enableFirst ? '继续学习' : '开始学习' }}</template>
                        <template v-else>{{ opts.info.price ? '购买' : '开始学习' }}</template>
                      </el-button> -->
                      <el-button
                        v-if="!opts.info.courseStatus && opts.info.buyStatus"
                        class="buy_btn"
                        type="primary"
                        @click="handleBuy"
                      >
                        {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
                      </el-button>
                      <el-button
                        v-if="!opts.info.courseStatus && !opts.info.buyStatus && opts.info.supportAloneSales"
                        class="buy_btn"
                        type="primary"
                        @click="handleBuy"
                      >
                        {{ opts.info.price ? "购买" : "开始学习" }}
                      </el-button>
                      <el-button
                        v-if="!opts.info.courseStatus && !opts.info.buyStatus && !opts.info.supportAloneSales"
                        disabled
                        class="buy_btn"
                        type="primary"
                      >
                        不支持单独售卖
                      </el-button>
                      <el-button
                        class="buy_btn"
                        v-if="
                          userInfo &&
                          opts.shopData?.config.vipEnableMarketing &&
                          !userInfo.isVip &&
                          opts.info.price > 0
                        "
                        type="warning"
                        @click="openVip"
                      >
                        开通会员
                      </el-button>
                    </div>
                    <div class="course_learn_msg">
                      <span
                        v-if="opts.shopData && opts.shopData.config.showLearnUserCount && opts.shopData.config.showCourseLearnUserCount"
                        class="learn_item"
                      >{{ opts.info.studyNum }}人已学习</span>
                      <span
                        class="learn_item icon_btn"
                        @click="handleCollection"
                      >
                        <span
                          :class="{
                            'icon-collection': !opts.info.collectStatus,
                            'icon-collections': opts.info.collectStatus,
                          }"
                          class="iconfont"
                        />
                        <span class="icon_text_name">收藏</span>
                      </span>
                      <span
                        class="learn_item icon_btn"
                        @click="handleShare"
                      >
                        <span class="iconfont icon-share" />
                        <span class="icon_text_name">分享</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_tabs">
            <template v-for="item in tabEnum">
              <div
                v-if="item.show"
                :key="item.command"
                :class="{ active: map.tabs === item.command }"
                class="nav_tabs_item"
                @click="handleChangeType(item.command)"
              >
                {{ item.label }}
              </div>
            </template>
          </div>
        </div>
        <div v-show="map.tabs === 'details'" class="detail_tab_pane">
          <course-details :course-info="opts.info" />
        </div>
        <div
          v-show="map.tabs === 'directory'"
          class="detail_tab_pane"
        >
          <div
            class="single_menu_item"
            @click="handleBuy"
          >
            <div class="single_item_name">
              <img
                class="video_icon mgr10"
                src="@/assets/video.svg"
              >
              <div class="single_item_title tx-ov">
                {{ opts.info.materialName }}
              </div>
            </div>
            <div class="single_item_status">
              {{ formatDuring(opts.info.duration * 1000) }}
            </div>
          </div>
        </div>
        <div
          v-show="map.tabs === 'notes'"
          class="detail_tab_pane note_pane"
        >
          <course-notes :course-info="opts.info" />
        </div>
        <div
          v-show="map.tabs === 'comments'"
          class="detail_tab_pane"
        >
          <course-comment :course-info="opts.info" />
        </div>
        <div
          v-show="map.tabs === 'courseware'"
          class="detail_tab_pane"
        >
          <course-ware :course-info="opts.info" />
        </div>
        <div
          v-if="ctrl.fixed"
          class="fixed_header"
        >
          <div class="fixed_content">
            <a
              class="nav_logo"
              href="/"
            >
              <img
                v-if="componentInfo.websiteLogo"
                :src="componentInfo.websiteLogo"
                alt=""
              >
            </a>
            <div class="nav_tabs_header">
              <template v-for="item in tabEnum">
                <div
                  v-if="item.show"
                  :key="item.command"
                  :class="{ active: map.tabs === item.command }"
                  class="nav_tabs_item"
                  @click="handleChangeType(item.command)"
                >
                  {{ item.label }}
                </div>
              </template>
            </div>
            <div class="course_btn">
              <template v-if="opts.info.courseStatus">
                <el-button
                  v-if="opts.info.courseStatus === 1"
                  class="buy_btn"
                  type="primary"
                  @click="handleMake"
                >
                  预约课程
                </el-button>
                <el-button
                  v-else-if="opts.info.courseStatus === 2"
                  class="buy_btn"
                  type="info"
                >
                  待开课
                </el-button>
                <el-button
                  v-else-if="opts.info.courseStatus === 3"
                  class="buy_btn"
                  type="primary"
                  @click="handleOpenOther"
                >
                  查看其它课程
                </el-button>
              </template>
              <!-- <el-button v-if="!opts.info.courseStatus" class="buy_btn" type="primary" @click="handleBuy">
                <template v-if="opts.info.buyStatus">{{ !opts.info.enableFirst ? '继续学习' : '开始学习' }}</template>
                <template v-else>{{ opts.info.price ? '购买' : '开始学习' }}</template>
              </el-button> -->
              <el-button
                v-if="!opts.info.courseStatus && opts.info.buyStatus"
                class="buy_btn"
                type="primary"
                @click="handleBuy"
              >
                {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
              </el-button>
              <el-button
                v-if="
                  !opts.info.courseStatus &&
                    !opts.info.buyStatus &&
                    opts.info.supportAloneSales
                "
                class="buy_btn"
                type="primary"
                @click="handleBuy"
              >
                {{ opts.info.price ? "购买" : "开始学习" }}
              </el-button>
              <el-button
                v-if="
                  !opts.info.courseStatus &&
                    !opts.info.buyStatus &&
                    !opts.info.supportAloneSales
                "
                disabled
                class="buy_btn"
                type="primary"
              >
                不支持单独售卖
              </el-button>
              <el-button
                class="buy_btn"
                v-if="
                  userInfo &&
                  opts.shopData?.config.vipEnableMarketing &&
                  !userInfo.isVip &&
                  opts.info.price > 0
                "
                type="warning"
                @click="openVip"
              >
                开通会员
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <client-only>
        <course-share
          v-model="ctrl.share"
          :info="opts.info"
        />
        <before-exam
          v-if="ctrl.showBeforeExam"
          :dialog-visible="ctrl.showBeforeExam"
          :exam-name="opts.info.examName"
          :paper-id="opts.info.paperId"
          :resource-id="opts.info.id"
          :resource-type="2"
          @close="closeDialog"
        />
        <before-exercise
          v-if="ctrl.showBeforeExercise"
          v-model="ctrl.showBeforeExercise"
          :practice-num="opts.info.practiceNum"
          :exam-name="opts.info.practiceName"
          :support-alone-sales="opts.info.supportAloneSales"
          @close="handleCloseExercise"
          @callback="handleOpenExercise"
        />
      </client-only>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import { useUserStore } from '../../stores/user'
import { courseAuthAppointment, getAuthCourseView, getCourseView, handleBeforeValid } from '../../api/course'
import { vipUserGoodsDiscount, authVipUserGoodsDiscount } from '@/api/vip'
import { formatDuring } from '../../utils'
import { getHearder } from '@/api/layouts'
import { collectionUserDelete, collectionUserSave } from '../../api/system'
import { ElMessage, ElMessageBox } from 'element-plus'
import cookie from '@/utils/cookies'
import BeforeExercise from '@/components/exam/beforeExercise.vue'
import BeforeExam from '@/components/exam/beforeExam.vue'
import { paperCheckStatus, paperRecordCheck } from '../../api/paper'
import { setStore } from '../../utils/storage'
const store = useUserStore()
const { getEnumList, getToken, getShopInfo } = store
const route = useRoute()
const router = useRouter()
const { data: componentInfo } = await useAsyncData('header', async (ctx) => {
  return getHearder()
})
const cookieData = cookie.getShop()
const head = ref(null)
const userInfo = computed(() => {
  return store.userView
})
const token = computed(() => {
  return getToken()
})
const map = reactive({
  id: '',
  tabs: 'details',
  superiorResourceId: [],
  relevanceType: 1, // 1:课程关联、2:专题关联
  isExamination: false, // 用户是否处于考试
  recordId: '' // 考试记录id
})
if (route.query.id) {
  map.id = route.query.id
}
if (route.query.superiorResourceId) {
  map.superiorResourceId = route.query.superiorResourceId
}

const opts = reactive({
  info: {
    discountPrice: 0,
    otherPrice: 0
  },
  PeriodTypeEnum: {},
  shopData: {}
})
const ctrl = reactive({
  loading: false,
  showDesc: false,
  courseware: false,
  share: false,
  fixed: false,
  showBeforeExam: false,
  showBeforeExercise: false
})

// 改变菜单
const handleChangeExam = (val) => {
  if (!token.value) {
    ElMessage.error('请登录后查看')
    return
  }
  if (!opts.info.buyStatus && opts.info.price > 0) {
    ElMessage.error('你尚未购买本课程')
    return false
  }
  if (val === 'practice') {
    if (!handleBeforeValid(opts.info)) {
      return false
    }
    ctrl.showBeforeExercise = true
  } else if (val === 'exam') {
    if (!token.value) {
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
      return false
    }
    if (!handleBeforeValid(opts.info)) {
      return false
    }
    if (!token.value) {
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
      return
    }
    paperCheckStatus(opts.info.paperId)
      .then((res) => {
        if (res === 1) {
          ctrl.showBeforeExam = true
        } else {
          ElMessage.error('该试卷已下架')
        }
      })
      .catch((e) => {})
  }
}

const closeDialog = (flag = false) => {
  ctrl.showBeforeExam = false
  if (flag) {
    if (!handleBeforeValid(opts.info)) {
      return false
    }
    paperRecordCheck().then((res) => {
      if (!res.isExamination) {
        map.isExamination = false
        setStore('examInfo', opts.info)
        router.push({
          path: '/exam/startExam',
          query: {
            controlShow: true,
            examType: 2,
            isExamination: map.isExamination,
            recordId: map.recordId,
            relevanceType: map.relevanceType
          }
        })
      } else {
        ElMessageBox.confirm('请继续未完成的考试', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          map.isExamination = true
          map.recordId = res.recordId
          setStore('examInfo', opts.info)
          router.push({
            path: '/exam/startExam',
            query: {
              controlShow: true,
              examType: res.examType,
              isExamination: map.isExamination,
              recordId: map.recordId,
              relevanceType: map.relevanceType
            }
          })
        })
      }
    })
  }
}
const handleCloseExercise = () => {
  ctrl.showBeforeExercise = false
}

const handleOpenExercise = () => {
  ctrl.showBeforeExercise = false
  setStore('practiceInfo', opts.info)
  router.push({
    path: '/practice/startPractice',
    query: {
      controlShow: true,
      examType: 2,
      courseId: opts.info.id,
      courseTypeName: 'video'
    }
  })
}

// 预约
const handleMake = () => {
  if (!token.value) {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  courseAuthAppointment({ id: opts.info.id }).then((res) => {
    if (res) {
      ElMessageBox.alert(
        '课程开课时，我们将以短信的形式通知您，请您留意哟~',
        '预约成功提醒',
        {
          confirmButtonText: '知道了',
          type: 'success',
          center: true
        }
      )
      opts.info.courseStatus = 2
    }
  })
}

// 购买课程
const handleBuy = () => {
  if (!handleBeforeValid(opts.info)) {
    return false
  }
  if (opts.info.courseStatus === 1) {
    handleMake()
    return
  }
  if (opts.info.courseStatus === 2) {
    return
  }
  if (opts.info.courseStatus === 3) {
    handleOpenOther()
    return
  }
  if (opts.info.price > 0 && !opts.info.buyStatus) {
    if (!opts.shopData.config.enabledPay) {
      ElMessage.error(opts.shopData.config.disablePayTips)
      return
    }
    if (!opts.shopData.config.enabledAliPay && !opts.shopData.config.enabledWxPay) {
      ElMessage.error(opts.shopData.config.disablePayTips)
      return
    }
  }
  if (opts.info.price > 0 && !opts.info.buyStatus) {
    if (!opts.info.publishStatus) {
      ElMessage.error('课程暂未发布')
      return false
    }
    if (token.value) {
      router.push({
        path: '/pay/buy',
        query: {
          id: map.id
        }
      })
    } else {
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
    }
  } else {
    if (
      !opts.info.enableNotLoginWatch &&
      !opts.info.buyStatus &&
      opts.info.price === 0 &&
      !token.value
    ) {
      ElMessage.error('请登录后再进行观看')
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
      return
    }
    const query = route.query || {}
    router.push({
      path: '/course/single',
      query: Object.assign(query, { id: map.id })
    })
  }
}


// 课程列表
const handleOpenOther = () => {
  router.push({
    path: '/course/list'
  })
}

// 顶部菜单显示
const handleScrollBody = () => {
  const app = document.querySelector('#app')
  const top = Math.floor(app.scrollTop || window.pageYOffset)
  if (top >= head.value.clientHeight - 10) {
    ctrl.fixed = true
  } else {
    ctrl.fixed = false
  }
}
// 分享
const handleShare = () => {
  ctrl.share = true
}

// 收藏
const handleCollection = () => {
  if (ctrl.isClick) {
    return false
  }
  ctrl.isClick = true
  if (!token.value) {
    const route = useRoute()
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  if (opts.info.collectStatus) {
    collectionUserDelete({ collectionType: 1, resourceId: opts.info.id })
      .then((res) => {
        ElMessage.success(res)
        ctrl.isClick = false
        opts.info.collectStatus = false
      })
      .catch(() => {
        ctrl.isClick = false
      })
  } else {
    collectionUserSave({ collectionType: 1, resourceId: opts.info.id })
      .then((res) => {
        ElMessage.success(res)
        ctrl.isClick = false
        opts.info.collectStatus = true
      })
      .catch(() => {
        ctrl.isClick = false
      })
  }
}

// 教师详情
const handleOpenTeacher = (teacher) => {
  router.push({
    path: '/teacher/view',
    query: {
      id: teacher.id
    }
  })
}


// tabs切换
const handleChangeType = (item) => {
  map.tabs = item
}
const tabEnum = computed(() => {
  return [
    { label: '课程介绍', command: 'details', show: true },
    {
      label: '课件下载',
      command: 'courseware',
      show: opts.info && opts.info.coursewareExist
    },
    {
      label: '学习笔记',
      command: 'notes',
      show: opts.info && opts.info.enableCourseNote
    },
    {
      label: '课程评论',
      command: 'comments',
      show: opts.info && opts.info.enableCourseComment
    }
  ]
})

const { data, pending } = await useAsyncData('courseVideoView' + route.query.id, () => {
  return new Promise((resolve) => {
    let courseFn = getAuthCourseView
    if (!token.value) {
      courseFn = getCourseView
    }
    Promise.allSettled([
      courseFn(map),
      getEnumList('CourseTypeEnum', 'obj'),
      getShopInfo()
    ]).then(([course, CourseTypeEnum, shopInfo]) => {
      const data = {}
      if (course.status === 'fulfilled') {
        data.course = course.value
      } else {
        data.course = {}
      }
      if (CourseTypeEnum.status === 'fulfilled') {
        data.CourseTypeEnum = CourseTypeEnum.value
      } else {
        data.CourseTypeEnum = []
      }
      if(shopInfo.status === 'fulfilled') {
        data.shopInfo = shopInfo.value
      } else {
        data.shopInfo = {}
      }
      resolve(data)
    })
  })
}, { initialCache: false })

if (!pending.value && data.value) {
  const d = data.value
  console.log('shopInfo', d.shopInfo)
  opts.PeriodTypeEnum = d.CourseTypeEnum
  opts.info = { ...opts.info, ...d.course }
  opts.shopData = d.shopInfo
  if (opts.info) {
    useHead({
      title: computed(() => `${opts.info.courseName ? opts.info.courseName + '-' + cookieData.shopName : '视频课详情'}`),
      meta: [
        {
          charset: 'utf-8'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: opts.info.courseName
        },
        {
          hid: 'description',
          name: 'description',
          content: opts.info.courseDesc
            ? opts.info.courseDesc
            : opts.info.courseName
        }
      ]
    })
  }
}

const openVip = () => {
  router.push({
    path: '/vip'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScrollBody, true)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollBody, true)
})
</script>

<style lang="scss" scoped>

.course_info_content {
  padding: 20px calc((100vw - 1200px) / 2);
  background-color: #ffffff;
  border-top: 1px solid #ebeef5;
}

.nav_tabs_header {
  background-color: #ffffff;
  display: flex;
  flex: 1;
  padding-left: 60px;

  .nav_tabs_item {
    display: flex;
    align-items: center;
    margin-right: 50px;
    font-size: 16px;
    line-height: 65px;
    white-space: nowrap;
  }

  .nav_tabs_item:hover {
    cursor: pointer;
    position: relative;
    color: var(--el-color-primary);
  }

  .nav_tabs_item:hover::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 64px;
    height: 3px;
    border-radius: 1.5px;
    background-color: var(--el-color-primary);
  }

  .active {
    position: relative;
    color: var(--el-color-primary);
  }

  .active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 64px;
    height: 3px;
    border-radius: 1.5px;
    background-color: var(--el-color-primary);
  }
}

.nav_tabs {
  padding: 20px calc((100vw - 1200px) / 2) 0;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;

  .nav_tabs_item {
    margin-right: 60px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 20px;
    color: #333333;
    position: relative;
    cursor: pointer;
  }

  .nav_tabs_item.active,
  .nav_tabs_item:hover {
    color: #2256f6;

    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      background: #2256f6;
      width: 64px;
      padding-top: 3px;
      left: 0;
      border-radius: 10px;
    }
  }

  .nav_tabs_item:last-child {
    margin-right: 0;
  }
}

.course_nav {
  margin-bottom: 20px;
}

.nav_course_title {
  color: #becadb;
  font-weight: 400;
  max-width: 115px;
}

.course_name_tag {
  padding: 5px 3px;
  border-radius: 5px 0;
  background: rgba(61, 127, 255, 0.1);
  display: inline-block;
  font-style: normal;
  width: 46px;
  position: relative;
  top: -2px;
  text-align: center;
  font-weight: normal;
  font-size: 10px;
  color: #3d7fff;
  margin-right: 4px;
}

.course_cover_img {
  width: 576px;
  height: 320px;
  object-fit: cover;
  border-radius: 5px;
}

.course_name {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}

.course_price_content {
  width: 100%;
}

.course_msg_content {
  width: 589px;
  margin-left: 30px;
  position: relative;
}

.course_message {
  display: flex;
  position: relative;
}

.course_int {
  margin-top: 5px;
  display: flex;

  .course_in_icon {
    min-width: 28px;
    margin-left: 8px;
    color: #666666;
    cursor: pointer;
  }

  .course_int_text {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #999999;
    width: 570px;
  }
  .loadmore {
    font-size: 14px;
    color: #666;
    cursor: default;
  }
}

.course_cell {
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;

  & + .course_cell {
    margin-top: 12px;
  }

  .course_cell_item {
    white-space: nowrap;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
    &.cu {
      cursor: pointer;
      &:hover {
        color: #2256f6;
      }
    }
  }

  .course_cell_item + .course_cell_item {
    padding-left: 24px;
    position: relative;
  }
}

.mgl3 {
  margin-left: 3px;
}

.price_old {
  color: #999999;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-decoration-line: line-through;
  margin-left: 5px;
}

.price_now {
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  color: #f01414;
}
.discount_price {
  font-size: 16px;
  color: #f61818;
}
.price_now .price_icon {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #f61818;
}

.course_btn_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.buy_btn {
  width: 154px;
  height: 40px;
  font-size: 16px;
}

.course_learn_msg {
  display: flex;
  align-items: center;
}

.learn_item {
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;

  & + .learn_item {
    padding-left: 20px;
  }
}

.icon_text_name {
  margin-left: 3px;
}

.icon_btn {
  cursor: pointer;

  .iconfont {
    //margin-right: 5px;
  }
}

.detail_tab_pane {
  padding: 30px;
  background-color: #ffffff;
  border-radius: 5px;
  width: 1200px;
  margin: 10px auto auto;
}


.slide-forward-leave-active {
  transition: all 1s;
  transform: translate(-100%);
}

// router2
.v-enter {
  transform: translateX(100%);
}

.v-enter-active {
  transition: all 3s;
}

.single_item_title {
  max-width: 550px;
}

.single_item_name .video_icon {
  font-size: 24px;
}

.single_item_name {
  display: flex;
  align-items: center;
}

.single_menu_item {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;
  border-bottom: 1px solid #ebeef5;

  &:hover {
    background: rgba(34, 86, 246, 0.05);
  }
}

.course_bottom {
  margin-top: 29px;
  width: 100%;
}

.fixed_header {
  position: fixed;
  top: 0;
  height: 66px;
  background-color: #ffffff;
  width: 100%;
  z-index: 10000;

  .fixed_content {
    width: 1200px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav_logo {
    width: 170px;
    height: 36px;

    img {
      width: 170px;
      height: 36px;
      object-fit: cover;
    }
  }
}

.detail_content {
  min-height: 100%;
}

.course_cell_valid {
  margin-top: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .course_tip {
    letter-spacing: 0.32em;
  }
}

.cover_teacher {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;

  & + .cover_teacher {
    transition: all 0.3s;
    margin-left: 3px;
  }

  &.hover {
    transform: scale(1.5);
    // border: 1px solid #2256F6;
    // box-shadow: 0px 5px 15px rgba(54, 41, 183, 0.06);
  }
}

.course_price_info {
  margin-top: 10px;
  margin-bottom: 12px;
  background: #f5f5f5;
  padding: 13px 10px 17px;

  .course_tip {
    letter-spacing: 0.6em;
  }
}

.course_tip {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

.teacher_warp_item {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
  height: 40px;
  & + .teacher_warp_item {
    margin-right: 10px;
  }

  .teacher_name {
    margin-left: 4px;
  }

  &:hover .teacher_name {
    color: #3d7fff;
  }
}

.flex_teacher {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 70px);

  .course_in_icon {
    width: 29px;
    cursor: pointer;
  }

  .course_cell_item.teacher_wrap {
    padding-right: 10px;
  }
}

.course_cell_item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-all;
  overflow: auto;
}

.course_cell_item.teacher_wrap {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  text-overflow: clip;
  overflow: hidden;
}

.valid_text {
  font-weight: 400;
  font-size: 14px;
  color: #f01414;
}

.course_desc_tip {
  line-height: 1.6;
  font-size: 14px;
  color: #999
}

</style>
